<template>
  <div class="card-padding histogram">
    <div class="header">
      <div class="main">
        近一月各渠道招新概况 TOP10
      </div>
      <div class="sub">
        总招新{{ member_count }}人
      </div>
    </div>
    <div class="body">
      <transition-group
        name="list"
        tag="div"
        class="histogramContent"
      >
        <div
          v-for="(line, index) in dataSource"
          :key="`${line.label}_${index}`"
          class="dataLine view-flex"
          :style="{ 'margin-bottom': `${rowMarginBottom}px` }"
        >
          <div
            class="label"
            :style="{ 'flex-basis': `${leftRolWidth}px`, 'line-height': `${rowHeight}px` }"
          >
            {{ line.label }}
          </div>

          <div
            class="number"
            :style="{
              'height': `${rowHeight}px`,
              background: `${rowBackground}`,
              width: `${computedWidth(line.number)}%`
            }"
          >
            {{ line.number }}
          </div>
        </div>
      </transition-group>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    leftRolWidth: {
      type: Number,
      default: 58
    },
    rowHeight: {
      type: Number,
      default: 24
    },
    rowBackground: {
      type: String,
      default: '#7092f6'
    },
    rowMarginBottom: {
      type: Number,
      default: 14
    }
  },
  data () {
    return {
      dataSource: [],
      max: 100,
      member_count: 0
    }
  },
  mounted () {
    this.getChannelList()
  },
  methods: {
    computedWidth (width) {
      if (!width) {
        return 0
      }
      return Number(width / this.max) * 100
    },
    getChannelList () {
      this.$api['home/index'].getChannelList().then((response) => {
        const { list, member_count } = response
        this.dataSource = list.map((item) => ({
          label: item.channel_name,
          number: item.count
        }))

        this.maxNumber = this.dataSource.reduce((total, current) => {
          if (current.number > total) {
            return current.number
          } else {
            return total
          }
        }, 0)

        this.member_count = member_count

        this.max =
          this.maxNumber % 10 === 0 ? this.maxNumber : this.maxNumber + (10 - (this.maxNumber % 10))
        console.log(this.max)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.histogramContent {
  width: 100%;
  transition: all 0.3s ease-in;

  .list-enter {
    .number {
      width: 50px !important;
    }
  }

  .list-enter-active {
    transition: width 1000ms cubic-bezier(0, 0, 0.2, 1) 0ms;
    .number {
      transition: width 1000ms cubic-bezier(0, 0, 0.2, 1) 0ms;
    }
  }

  .dataLine {
    .label {
      font-size: 12px;
      color: grey;
      flex-shrink: 0;
    }
    .number {
      padding-left: 6px;
      color: white;

      min-width: 50px;
    }
  }
}
.card-padding {
  padding: 20px;
  background: #fff;
  margin-bottom: 20px;

  &.histogram {
    .main {
      font-size: 18px;
      color: black;
      font-weight: 500;
    }
    .sub {
      font-size: 12px;
      color: grey;
    }
    .body {
      margin-top: 36px;
    }
  }
}
@media only screen and (max-width: 1600px) {
  .histogram {
    .main {
      font-size: 14px;
    }
  }
}
</style>
